import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService } from "../../../shared/base-api-template-service.model";
import { Core2Config } from "../../../shared/core2Config";
import { JobDocLineLinkContainerModel } from "../../../../../../../models/aggregates/erp/delivery/job";
import { BasicApiResponseModel } from "../../../shared/api-response.model";
import { Observable } from "rxjs";
import { ApiVisa } from "../../../shared/api-visa.model";

@Injectable({
  providedIn: "root",
})
export class JobDocLineLinkService extends BaseApiTemplateService<JobDocLineLinkContainerModel> {
  readonly url =
    Core2Config.DOMAIN_TEST_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    "del/job-docline-links";

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_TEST_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "del/job-docline-links";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX + "del/job-docline-links";
    this.httpClient = http;
  }

  // update a job-doc-line-link to update the serial number 
  public putSerialNumber(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<JobDocLineLinkContainerModel>> {
    // https://api.akaun.cloud/core2/tnt/dm/del/job-docline-links/multi-update/backoffice-ep
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl =
        visa.api_domain_url +
        this.endpoint_path +
        "/multi-update/backoffice-ep";
    }
    return this.httpClient.put<
      BasicApiResponseModel<JobDocLineLinkContainerModel>
    >(this.apiUrl, dtoObject, this.getHttpHeader(visa));
  }
}
